// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayControllersModelsClsInboundAddress } from './tCApiGatewayControllersModelsClsInboundAddress.js';
import type { TCApiGatewayControllersModelsClsInboundConsent } from './tCApiGatewayControllersModelsClsInboundConsent.js';
import type { TCApiGatewayControllersModelsClsInboundDocument } from './tCApiGatewayControllersModelsClsInboundDocument.js';
import type { TCApiGatewayControllersModelsClsInboundHco } from './tCApiGatewayControllersModelsClsInboundHco.js';
import type { TCApiGatewayControllersModelsClsInboundPayor } from './tCApiGatewayControllersModelsClsInboundPayor.js';
import type { TCApiGatewayControllersModelsClsInboundPrescriber } from './tCApiGatewayControllersModelsClsInboundPrescriber.js';
import type { TCApiGatewayControllersModelsClsInboundPrescription } from './tCApiGatewayControllersModelsClsInboundPrescription.js';
import type { TCApiGatewayControllersModelsClsInboundServiceRequested } from './tCApiGatewayControllersModelsClsInboundServiceRequested.js';
import type { TCApiGatewayControllersModelsClsInboundSurvey } from './tCApiGatewayControllersModelsClsInboundSurvey.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersModelsClsInboundEnrollment {
    'tcPatientIs'?: string | null;
    'pcFirstName'?: string | null;
    'tcMiddleName'?: string | null;
    'pcLastName'?: string | null;
    'tcOtherBrands'?: string | null;
    'pcDateofBirth'?: string | null;
    'pcGender'?: string | null;
    'tCsuffix'?: string | null;
    'tcCommunicationLanguage'?: string | null;
    'tcusResident'?: string | null;
    'pcPatientEmail'?: string | null;
    'pcPhone'?: string | null;
    'tcMobilePhone'?: string | null;
    'tcBestTimetoContact'?: string | null;
    'tcPrimaryPhone'?: string | null;
    'tcWorkPhone'?: string | null;
    'pcPreferredChannel'?: string | null;
    'tcVoiceMailOptIn'?: boolean;
    'pcCaregiverSalutation'?: string | null;
    'pcCaregiverFirstName'?: string | null;
    'pcCaregiverRelationshiptoPatient'?: string | null;
    'tcCaregiverDetails'?: string | null;
    'tcCaregiver2LastName'?: string | null;
    'tcCaregiver2Phone'?: string | null;
    'tcCaregiver2EmailAddress'?: string | null;
    'pcCaregiverLastName'?: string | null;
    'tcCaregiverPhone'?: string | null;
    'tcCaregiverEmailAddress'?: string | null;
    'tcCaregiver2Salutation'?: string | null;
    'tcCaregiver2FirstName'?: string | null;
    'tcCaregiver2RelationshiptoPatient'?: string | null;
    'tcCaregiver2Details'?: string | null;
    'programCode'?: string | null;
    'copayId'?: string | null;
    'patientAddresses'?: Array<TCApiGatewayControllersModelsClsInboundAddress> | null;
    'payor'?: Array<TCApiGatewayControllersModelsClsInboundPayor> | null;
    'prescriber'?: Array<TCApiGatewayControllersModelsClsInboundPrescriber> | null;
    'prescription'?: Array<TCApiGatewayControllersModelsClsInboundPrescription> | null;
    'hco'?: Array<TCApiGatewayControllersModelsClsInboundHco> | null;
    'consent'?: Array<TCApiGatewayControllersModelsClsInboundConsent> | null;
    'serviceRequested'?: Array<TCApiGatewayControllersModelsClsInboundServiceRequested> | null;
    'surveys'?: Array<TCApiGatewayControllersModelsClsInboundSurvey> | null;
    'documents'?: Array<TCApiGatewayControllersModelsClsInboundDocument> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersModelsClsInboundEnrollment>> = [
        {
            "name":     "tcPatientIs",
            "baseName": "tcPatientIs",
            "type":     "string"
        },
        {
            "name":     "pcFirstName",
            "baseName": "pcFirstName",
            "type":     "string"
        },
        {
            "name":     "tcMiddleName",
            "baseName": "tcMiddleName",
            "type":     "string"
        },
        {
            "name":     "pcLastName",
            "baseName": "pcLastName",
            "type":     "string"
        },
        {
            "name":     "tcOtherBrands",
            "baseName": "tcOtherBrands",
            "type":     "string"
        },
        {
            "name":     "pcDateofBirth",
            "baseName": "pcDateofBirth",
            "type":     "string"
        },
        {
            "name":     "pcGender",
            "baseName": "pcGender",
            "type":     "string"
        },
        {
            "name":     "tCsuffix",
            "baseName": "tCsuffix",
            "type":     "string"
        },
        {
            "name":     "tcCommunicationLanguage",
            "baseName": "tcCommunicationLanguage",
            "type":     "string"
        },
        {
            "name":     "tcusResident",
            "baseName": "tcusResident",
            "type":     "string"
        },
        {
            "name":     "pcPatientEmail",
            "baseName": "pcPatientEmail",
            "type":     "string"
        },
        {
            "name":     "pcPhone",
            "baseName": "pcPhone",
            "type":     "string"
        },
        {
            "name":     "tcMobilePhone",
            "baseName": "tcMobilePhone",
            "type":     "string"
        },
        {
            "name":     "tcBestTimetoContact",
            "baseName": "tcBestTimetoContact",
            "type":     "string"
        },
        {
            "name":     "tcPrimaryPhone",
            "baseName": "tcPrimaryPhone",
            "type":     "string"
        },
        {
            "name":     "tcWorkPhone",
            "baseName": "tcWorkPhone",
            "type":     "string"
        },
        {
            "name":     "pcPreferredChannel",
            "baseName": "pcPreferredChannel",
            "type":     "string"
        },
        {
            "name":     "tcVoiceMailOptIn",
            "baseName": "tcVoiceMailOptIn",
            "type":     "boolean"
        },
        {
            "name":     "pcCaregiverSalutation",
            "baseName": "pcCaregiverSalutation",
            "type":     "string"
        },
        {
            "name":     "pcCaregiverFirstName",
            "baseName": "pcCaregiverFirstName",
            "type":     "string"
        },
        {
            "name":     "pcCaregiverRelationshiptoPatient",
            "baseName": "pcCaregiverRelationshiptoPatient",
            "type":     "string"
        },
        {
            "name":     "tcCaregiverDetails",
            "baseName": "tcCaregiverDetails",
            "type":     "string"
        },
        {
            "name":     "tcCaregiver2LastName",
            "baseName": "tcCaregiver2LastName",
            "type":     "string"
        },
        {
            "name":     "tcCaregiver2Phone",
            "baseName": "tcCaregiver2Phone",
            "type":     "string"
        },
        {
            "name":     "tcCaregiver2EmailAddress",
            "baseName": "tcCaregiver2EmailAddress",
            "type":     "string"
        },
        {
            "name":     "pcCaregiverLastName",
            "baseName": "pcCaregiverLastName",
            "type":     "string"
        },
        {
            "name":     "tcCaregiverPhone",
            "baseName": "tcCaregiverPhone",
            "type":     "string"
        },
        {
            "name":     "tcCaregiverEmailAddress",
            "baseName": "tcCaregiverEmailAddress",
            "type":     "string"
        },
        {
            "name":     "tcCaregiver2Salutation",
            "baseName": "tcCaregiver2Salutation",
            "type":     "string"
        },
        {
            "name":     "tcCaregiver2FirstName",
            "baseName": "tcCaregiver2FirstName",
            "type":     "string"
        },
        {
            "name":     "tcCaregiver2RelationshiptoPatient",
            "baseName": "tcCaregiver2RelationshiptoPatient",
            "type":     "string"
        },
        {
            "name":     "tcCaregiver2Details",
            "baseName": "tcCaregiver2Details",
            "type":     "string"
        },
        {
            "name":     "programCode",
            "baseName": "programCode",
            "type":     "string"
        },
        {
            "name":     "copayId",
            "baseName": "copayId",
            "type":     "string"
        },
        {
            "name":     "patientAddresses",
            "baseName": "patientAddresses",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundAddress>"
        },
        {
            "name":     "payor",
            "baseName": "payor",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundPayor>"
        },
        {
            "name":     "prescriber",
            "baseName": "prescriber",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundPrescriber>"
        },
        {
            "name":     "prescription",
            "baseName": "prescription",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundPrescription>"
        },
        {
            "name":     "hco",
            "baseName": "hco",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundHco>"
        },
        {
            "name":     "consent",
            "baseName": "consent",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundConsent>"
        },
        {
            "name":     "serviceRequested",
            "baseName": "serviceRequested",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundServiceRequested>"
        },
        {
            "name":     "surveys",
            "baseName": "surveys",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundSurvey>"
        },
        {
            "name":     "documents",
            "baseName": "documents",
            "type":     "Array<TCApiGatewayControllersModelsClsInboundDocument>"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersModelsClsInboundEnrollment.attributeTypeMap;
    }
}
